import { uploadCosImage, UploadOptions } from '@/material/form-upload/service';

/**
 * base64 to file
 * @param base64Data
 * @param fileName
 * @returns
 */
export const base64ToFile = (base64Data: string, fileName: string) => {
  const sliceSize = 1024;
  const byteCharacters = atob(base64Data.split(',')[1]);
  const byteArrays = [];
  let offset = 0;
  while (offset < byteCharacters.length) {
    const slice = byteCharacters.slice(offset, offset + sliceSize);
    const byteNumbers = new Array(slice.length);
    for (let i = 0; i < slice.length; i++) {
      byteNumbers[i] = slice.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    byteArrays.push(byteArray);
    offset += sliceSize;
  }
  const blob = new Blob(byteArrays, { type: 'application/octet-stream' });
  const file = new File([blob], fileName, { type: 'image/png' });
  return file;
};

/**
 * 下载图片并上传
 * @param imageUrl
 * @returns
 */
export async function downloadImageAndUpload(
  imageUrl: string,
  options?: UploadOptions,
) {
  try {
    // 使用 fetch() 函数获取图片
    const response = await fetch(imageUrl);

    if (!response.ok) {
      throw new Error(`Error downloading image: ${response.statusText}`);
    }

    // 获取图片的 Blob 数据
    const imageBlob = await response.blob();

    // 使用 Blob 数据创建一个 File 对象
    const imageFile = new File([imageBlob], 'image.jpg', { type: 'image/jpeg' });

    // 上传 imageFile
    const res = await uploadCosImage(imageFile, options);
    if (!res?.response?.url) {
      return {
        code: 50010,
      };
    }
    return {
      code: 0,
      url: res.response.url,
      localPath: res?.response?.localPath,
    };
  } catch (error) {
    return {
      code: 50010,
    };
  }
}

/**
 * 将URL转换为File对象
 * @param url
 * @param fileName
 * @returns
 */
export async function urlToFile(url: string, fileName: string) {
  try {
    // 使用fetch() API从URL获取二进制数据
    const response = await fetch(url);
    const data = await response.blob();

    // 使用URL.createObjectURL()方法创建一个指向Blob对象的URL
    const blobUrl = URL.createObjectURL(data);

    // 使用new File()构造函数创建一个File对象
    const file = new File([data], fileName, { type: data.type });

    // 释放Blob URL
    URL.revokeObjectURL(blobUrl);

    return file;
  } catch (error) {
    console.error('Error converting URL to File:', error);
    return null;
  }
}
